var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"record"},[_c('div',{staticClass:"multi-table"},[_c('multi-table',{attrs:{"columns":_vm.columns,"list":_vm.list,"total":_vm.total},on:{"gePartnerList":_vm.gePartnerList}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }